import React, { Component } from "react";

class CompanyForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            CompanyTitle: this.props.creditabilityData.companyName,
            CreditApplicationId: this.props.creditabilityData.creditApplicationId,
            ReferenceCode: '',
            BusinessType: this.props.creditabilityData.typeOfBusiness,
            BusinessDate: this.props.creditabilityData.inBusinessSince,
            OperationType: '',
            OtherCompanyName: this.props.creditabilityData.parentCompanyName,
            OtherBusinessDate: this.props.creditabilityData.parentInBusinessSince,
        };
        this.handleChange = this.handleChange.bind(this)    
    }
    handleChange(event) {
        this.props.onChange(event);
    }
    render() {
        console.log("props", this.props.creditabilityData)
        return (
            <form>
                <div className="row">
                    <div className="col-md-6">
                            <div className="form-group">
                                <label className="control-label">
                                    Company Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="CompanyTitle"
                                    id="CompanyTitle"
                                    value={this.state.CompanyTitle || ''}
                                    onChange={(val) => this.handleChange(val)}
                                />
                            </div>
                            <div className="form-group">
                                <label className="control-label">
                                    Type of Business
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="BusinessType"
                                    id="BusinessType"
                                    value={this.state.BusinessType}
                                    onChange={(val) => this.handleChange(val)}
                                />
                            </div>
                            <div className="form-group">
                                <label className="control-label">
                                    In Business Since
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="BusinessDate"
                                    id="BusinessDate"
                                    value={this.state.BusinessDate}
                                    onChange={(val) => this.handleChange(val)}
                                />
                            </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>
                                Which Business Operates
                            </label>
                            <select
                                name="OperationType"
                                id="OperationType"
                                className="form-control"
                                onChange={(val) => this.handleChange(val)} 
                            >
                                <option value="corporation">Corporation</option>
                                <option value="partnership">Partnership</option>
                                <option value="proprietorship">Proprietorship</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="control-label">
                                If Division/Subsidiary, Name of Parent Company
                            </label>
                            <input
                                type="text"
                                className="form-control wizard-stage-1-username"
                                name="OtherCompanyName"
                                id="OtherCompanyName"
                                value={this.state.OtherCompanyName}
                                onChange={(val) => this.handleChange(val)}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">
                                In Business Since
                            </label>
                            <input
                                type="text"
                                className="form-control wizard-stage-1-username"
                                name="OtherBusinessDate"
                                id="OtherBusinessDate"
                                value={this.state.OtherBusinessDate}
                                onChange={(val) => this.handleChange(val)}
                            />
                        </div>
                    </div>
                </div>
                <ul className="pager wizard">
                    <li className="next">
                        <button className="btn btn-primary" onClick={() => this.props.onNextPage()} > Next </button>
                    </li>
                </ul>
            </form>
            );
    }
}
export default CompanyForm;


// WEBPACK FOOTER //
// ./src/view/Creditability/CompanyForm.jsx